// Copyright (c) 2018 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import AmountOfUseModalBody from './amount-of-use-modal-body';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import ModalHeader from '../modal-header';
import {WarrantyMediumModal} from '../../../shared/components/modal';

const AmountOfUseModal = props =>
    <WarrantyMediumModal
        className='amount-of-use-modal'
        isOpen={props.isModalOpen}
    >
        <ModalHeader
            modalTitle='AMOUNT_OF_USE'
            onCloseButtonClick={props.onCloseButtonClick}
        />
        <AmountOfUseModalBody
            measurementReadings={props.measurementReadings}
        />
    </WarrantyMediumModal>;

AmountOfUseModal.displayName = 'AmountOfUseModal';
AmountOfUseModal.propTypes = {
    isModalOpen: PropTypes.bool.isRequired,
    measurementReadings: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    onCloseButtonClick: PropTypes.func.isRequired
};

export default AmountOfUseModal;



// WEBPACK FOOTER //
// ./src/shared/components/amount-of-use-with-modal/amount-of-use-modal.js